export enum eFunnelDeletedProgressEvent {
  LEADS = 'LEADS',
  MOVED = 'MOVED',
  DELETED = 'DELETED',
  ERROR = 'ERROR',
}
